import { render, staticRenderFns } from "./FilterProperty.vue?vue&type=template&id=64bda0cf&scoped=true&"
import script from "./FilterProperty.vue?vue&type=script&lang=js&"
export * from "./FilterProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bda0cf",
  null
  
)

export default component.exports